// ============= INTELLIGENCE-LAYER CHAT ROUTING =============
// All chat traffic routes to the intelligence-layer NL→SQL agent
// (`client-project-chat-prod-port`). The legacy `client-project-chat` slug is
// being retired: this PR redirects every caller to the prod-port function, and
// the legacy slug is deleted in Supabase once this is merged and verified.
//
// Kept as a single chat-URL chokepoint so the slug lives in exactly one place.

export function getClientProjectChatUrl(): string {
  const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
  return `${SUPABASE_URL}/functions/v1/client-project-chat-prod-port`;
}
